import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 32px auto 0;
`;

export const CompletedRow = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;
	margin-bottom: 16px;
`;

export const SliderWrapper = styled.div`
	position: relative;
	margin-bottom: 16px;
`;

export const EndedChip = styled.div`
	padding: 6px 8px;
	border-radius: 16px;
	background-color: ${({ theme }) => theme.colors.text.error};

	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const Title = styled.h2`
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 14px;
`;

export const Subtitle = styled.p`
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	margin-bottom: 32px;
`;

export const MainWinnerGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: 1fr;
	grid-column-gap: 16px;

	margin-bottom: 16px;

	@media (max-width: 992px) {
		grid-template-columns: repeat(1, 1fr);
		grid-row-gap: 16px;
	}
`;
